/**
 * The feedback route, as the phone uses it. One POST, open to guests — the
 * session cookie rides along when there is one, and the server names the
 * reporter from that rather than from anything sent here.
 */
import type { FeedbackContext, FeedbackKind, FeedbackReceipt } from '@tv-casino/shared';

export type { FeedbackReceipt };

export interface FeedbackRequest {
  kind: FeedbackKind;
  message: string;
  contact?: string;
  context: FeedbackContext;
}

export async function sendFeedback(body: FeedbackRequest): Promise<FeedbackReceipt> {
  const res = await fetch('/api/feedback', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let message = 'That did not send. Try again in a moment.';
    try {
      const failure = (await res.json()) as { message?: string };
      if (failure.message) message = failure.message;
    } catch {
      // keep the fallback
    }
    throw new Error(message);
  }
  return (await res.json()) as FeedbackReceipt;
}
